module.exports = {
  AKTIV: { api: 'AKTIV', human: 'aktiv' },
  INAKTIV: { api: 'INAKTIV', human: 'inaktiv' },
  ABGELEHNT: { api: 'ABGELEHNT', human: 'abgelehnt' },
  ABGELAUFEN: { api: 'ABGELAUFEN', human: 'abgelaufen' },
  RUHEND: { api: 'RUHEND', human: 'ruhend' },
  STORNO_VORGEMERKT: { api: 'STORNO_VORGEMERKT', human: 'Storno vorgemerkt' },
  STORNIERT: { api: 'STORNIERT', human: 'storniert' }
}
